export default __webpack_public_path__ + "static/signature1-0fb6065954a9be45130d4ab33f191c60.jpg";